import { Injectable } from '@angular/core';
import { LoadingController, LoadingOptions } from '@ionic/angular';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(
    private _loadingCtrl: LoadingController
  ) { }

  /**
   * Show loading screen
   *
   * @param   {object}  options  Ionic loading properties
   * @return  {void}
   */

  public show = async (options: LoadingOptions = {}): Promise<any> => {
    try {
      // Dismiss any existing loader first
      await this.dismiss();

      /** Merge options with defaults */
      const loader = await this._loadingCtrl.create(Object.assign({
        spinner: 'crescent',
        duration: 0,
        translucent: true,
        backdropDismiss: false,
        keyboardClose: false
      }, options));

      return await loader.present();
    } catch (error) {
      console.warn('Loader show error (safe to ignore):', error);
      return Promise.resolve();
    }
  }

  /**
   * Dismiss loading screen
   *
   * @return  {void}
   */

  public dismiss = async (): Promise<boolean> => {
    try {
      if (this._loadingCtrl) {
        const topLoader = await this._loadingCtrl.getTop();
        if (topLoader) {
          return await topLoader.dismiss();
        }
      }
      return Promise.resolve(true);
    } catch (error) {
      // Silently handle overlay errors
      console.warn('Loader dismiss error (safe to ignore):', error);
      return Promise.resolve(true);
    }
  }

  /**
 * Show loading screen
 *
 * @param   {object}  options  Ionic loading properties
 * @return  {Observable<unknown>}
 */
  public start = (options: LoadingOptions = {}): Observable<unknown> => {
    return from(this.show(options));
  }



}
